import AppSetting from "config/AppSetting";
import { matchPath } from "react-router-dom";
import { IRoutes } from "./types";

const getRouters = (() => {
  let cache: IRoutes | null = null;
  return (): IRoutes => {
    if (!cache) {
      cache = AppSetting.localStorageValue.routes.get();
    }
    return cache as IRoutes;
  };
})();

const getParams = () => {
  const pathname = window.location.pathname;
  const routers = getRouters();

  for (const route of routers) {
    const match = matchPath(pathname, { path: route.url, exact: true });
    if (match) {
      return {
        key: route.key,
        params: match.params,
        pattern: route.url,
      };
    }
  }
  return null;
};

export { getParams };
